// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CabBreedingFemale, CabBreedingFemaleSchema } from 'api/gen/CabBreedingFemale';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PageMetadata, PageMetadataSchema } from 'api/gen/PageMetadata';

const requiredPart = t.interface({
  content: t.union([t.array(CabBreedingFemaleSchema), t.null]),
  page: t.union([PageMetadataSchema, t.null]),
});

export const PagedModelCabBreedingFemaleSchema = excess(requiredPart);

export interface PagedModelCabBreedingFemale extends t.TypeOf<typeof PagedModelCabBreedingFemaleSchema> {}
